import {
    UPDATE_MY_PROJECTS_LIST,
    UPDATE_SELECTED_PROJECTS,
    APPLY_CHANGES,
    UPDATE_CHANGED_PROJECTS,
    CANCEL_CHANGES,
    SUBMIT_CHANGES,
    ON_HEADER_CLICK,
    ON_SECTION_RENDER,
    UPDATE_CURRENT_INDEX,
    UPDATE_INPUT_HEADER_LIST,
    UPDATE_MENU_ACTIVE,
    ON_MENU_HIDE,
    ON_APPLY_FILTER,
    ON_HEADER_FILTER_CHANGE,
    ON_SORT_CHANGE,
    UPDATE_SORT_BY,
    ON_INPUT_HEADER_VALUE_CHANGE,
    ON_COLUMN_REORDER,

    UPDATE_LIST_ORDER,
    UPDATE_SORT_INDEX,
    UPDATE_SORT_TYPE,
    UPDATE_CUSTOM_COL_ORDER,
    CLEAR_CUSTOM_COL_ORDER,

    UPDATE_HEADER_FILTER,
    REMOVE_HEADER_FILTER,
    ON_INPUT_CHANGE,
    UPDATE_INPUT_VALUE,
    ON_SUBMIT,
    ON_ROW_SIZE_CHANGE,
    UPDATE_ROW_SIZE,
    UPDATE_MAX_ROW_SIZE,
    CLEAR_SELECTED_PROJECTS,
    TOGGLE_POPUP,
    UPDATE_POPUP_PAGE,
    POST_PROJECT_CHANGES_START,
    POST_PROJECT_CHANGES_SUCCESS,
    POST_PROJECT_CHANGES_ERROR,
    CLEAR_CHANGES,
    FINISH_LOADING,
    UPDATE_ERRORS,
    SELECT_CUSTOM_VIEW,
    UPDATE_ALL_HEADER_FILTERS,
    RESET_HEADER_FILTERS,
    SHOW_CHANGED_PROJECTS,
    TOGGLE_NOTIFY,
    FILTER_CHANGE
} from './constants'

const updateMyProjectsList = (list) => ({ type: UPDATE_MY_PROJECTS_LIST, list })
const updateSelectedProjectsAction = (project) => ({ type: UPDATE_SELECTED_PROJECTS, id: project})
const clearSelectedProjects = () => ({ type: CLEAR_SELECTED_PROJECTS })
const applyChangesToProjectsAction = (formDetails, formType) => ({ type: APPLY_CHANGES, formDetails, formType })

const updateChangedProjects = (projects) => ({ type: UPDATE_CHANGED_PROJECTS, projects })

const cancelChangesPopup = () => ({ type: CANCEL_CHANGES })
const clearChanges = () => ({ type: CLEAR_CHANGES })
const submitChanges = () => ({ type: SUBMIT_CHANGES })

const onHeaderClick = (columnIndex) => ({ type: ON_HEADER_CLICK, columnIndex })
const updateCurrentIndex = (columnIndex) => ({ type: UPDATE_CURRENT_INDEX, columnIndex })
const updateInputHeaderList = (filters) => ({ type: UPDATE_INPUT_HEADER_LIST, filters })
const updateMenuActive = (active) => ({ type: UPDATE_MENU_ACTIVE, active })
const onMenuHide = () => ({ type: ON_MENU_HIDE })
const onInputHeaderValueChange = (value) => ({ type: ON_INPUT_HEADER_VALUE_CHANGE, value })


const onApplyFilter = (columnIndex, filter, sort) => ({ type: ON_APPLY_FILTER, columnIndex, filter, sort })
const onHeaderFilterChange = (columnIndex, filter) => ({ type: ON_HEADER_FILTER_CHANGE, columnIndex, filter })

const onSortChange = (columnIndex, value) => ({ type: ON_SORT_CHANGE, columnIndex, value })
const onColumnReorder = (columnsMoved, targetIndex) => ({ type: ON_COLUMN_REORDER, columnsMoved, targetIndex })

const updateListOrder = (listOrder) => ({ type: UPDATE_LIST_ORDER, listOrder })
const updateSortIndex = (index) => ({ type: UPDATE_SORT_INDEX, index })
const updateSortType = (value) => ({ type: UPDATE_SORT_TYPE, value })
const updateSortBy = (value) => ({ type: UPDATE_SORT_BY, value })

const updateCustomColOrder = (colOrder) => ({ type: UPDATE_CUSTOM_COL_ORDER, colOrder})
const clearCustomColOrder = () => ({ type: CLEAR_CUSTOM_COL_ORDER })

const updateHeaderFilter = (filterType, filter) => ({ type: UPDATE_HEADER_FILTER, filterType, filter })
const removeHeaderFilter = (filter) => ({ type: REMOVE_HEADER_FILTER, filter })

const onInputChange = (value) => ({ type: ON_INPUT_CHANGE, value })
const updateInput = (value) => ({ type: UPDATE_INPUT_VALUE, value })

const onSubmit = () => ({ type: ON_SUBMIT })

const onRowSizeChange = (size) => ({ type: ON_ROW_SIZE_CHANGE, size })
const updateRowSize = (size) => ({ type: UPDATE_ROW_SIZE, size })

const onSectionRender = (start, stop) => ({ type: ON_SECTION_RENDER, start, stop })

const updateMaxRowSize = (size) => ({ type: UPDATE_MAX_ROW_SIZE, size })

const onTogglePopup = () => ({ type: TOGGLE_POPUP })
const onToggleCancelPopup = () => ({ type: TOGGLE_POPUP })
const updatePopupPage = (page) => ({ type: UPDATE_POPUP_PAGE, page})

const startPostProjectChanges = () => ({ type: POST_PROJECT_CHANGES_START })
const postProjectChangesSuccess = () => ({ type: POST_PROJECT_CHANGES_SUCCESS })
const postProjectChangesError = () => ({ type: POST_PROJECT_CHANGES_ERROR })
const showChangedProjects = (list) => ({type: SHOW_CHANGED_PROJECTS, list})

const finishLoading = () => ({ type: FINISH_LOADING })
const updateErrors = (errors) => ({ type: UPDATE_ERRORS, errors})

const onSelectCustomView = (view) => ({ type: SELECT_CUSTOM_VIEW, view })
const updateAllHeaderFilters = (filters) => ({ type: UPDATE_ALL_HEADER_FILTERS, filters})
const resetProductFilters = () => ({ type: RESET_HEADER_FILTERS })

const toggleNotify = (toggle) => ({ type: TOGGLE_NOTIFY, toggle })

const filterChange = (value) => ({ type: FILTER_CHANGE, value })

export {
    updateMyProjectsList,
    updateSelectedProjectsAction,
    clearSelectedProjects,
    applyChangesToProjectsAction,
    updateChangedProjects,
    cancelChangesPopup,
    submitChanges,
    onHeaderClick,
    updateCurrentIndex,
    updateInputHeaderList,
    updateMenuActive,
    onMenuHide,
    onApplyFilter,
    onHeaderFilterChange,
    onSortChange,
    onInputHeaderValueChange,
    onColumnReorder,
    updateListOrder,
    updateSortIndex,
    updateSortType,
    updateSortBy,
    updateCustomColOrder,
    clearCustomColOrder,
    updateHeaderFilter,
    removeHeaderFilter,
    onInputChange,
    updateInput,
    onSubmit,
    onRowSizeChange,
    updateRowSize,
    onSectionRender,
    updateMaxRowSize,
    onTogglePopup,
    updatePopupPage,
    startPostProjectChanges,
    postProjectChangesSuccess,
    postProjectChangesError,
    onToggleCancelPopup,
    clearChanges,
    finishLoading,
    updateErrors,
    onSelectCustomView,
    updateAllHeaderFilters,
    resetProductFilters,
    showChangedProjects,
    toggleNotify,
    filterChange
}